import React from 'react'
import PropTypes from 'prop-types'
import {
    getUserData,
    isAuthenticated,
    subscribe,
    unsubscribe,
    setAccessToken,
    getAccessToken,
    setRefreshToken, setUserData, setTimeExp, setRoles
} from "../services/AuthServices"
import queryString from "query-string"
import {parseJwt} from './parseToken'
import {stripAuthParams} from './urlParams'

class WithAuthentication extends React.Component {
    constructor(props) {
        super(props)

        const {history} = this.props
        const {location} = history

        if (location.search !== '' || location.hash !== '') {
            const params = {
                ...queryString.parse(location.search),
                ...queryString.parse(location.hash)
            }
            const accessTokenOld = getAccessToken()
            let tokenSaved = false

            if (params.token && !accessTokenOld) {
                setAccessToken(params.token)
                const timeExp = parseJwt(params.token).exp - parseJwt(params.token).iat
                setUserData(parseJwt(params.token).permissions)
                setRoles(parseJwt(params.token).roles)
                setTimeExp((timeExp - 300)*1000 + new Date().getTime())
                tokenSaved = true
            }

            if (params.refresh) {
                setRefreshToken(params.refresh)
            }

            if (params.token || params.refresh) {
                /*
                 * Giữ lại `search` sau khi đã bỏ token: đây là chặng cuối của share-link. `loginUrl`
                 * gửi nguyên bộ lọc sang 3D và 3D trả đúng URL đó về, nhưng nếu ở đây cắt về mỗi
                 * `pathname` thì người nhận link đăng nhập xong vẫn đáp xuống bộ lọc mặc định và đọc
                 * một bộ số khác hẳn — hỏng im lặng, không có dấu hiệu gì.
                 *
                 * Token thì vẫn phải bỏ (FAC-25086): `stripAuthParams` lo phần đó, còn `hash` bị bỏ
                 * luôn vì gán lại URL không kèm nó.
                 */
                const cleanUrl = location.pathname + stripAuthParams(location.search)

                if (tokenSaved) {
                    window.location.href = cleanUrl
                } else {
                    window.history.replaceState({}, '', cleanUrl)
                }
            }
        }

        this.state = {
            isAuthenticated: isAuthenticated(),
            user: getUserData()
        }
    }

    componentDidMount() {
        subscribe(this._handleAuthChange)
    }

    componentWillUnmount() {
        unsubscribe(this._handleAuthChange)
    }

    _handleAuthChange = () => {
        this.setState({
            isAuthenticated: isAuthenticated(),
            user: getUserData()
        })
    }

    render() {
        return this.props.children(this.state)
    }
}

WithAuthentication.propTypes = {
    children: PropTypes.func.isRequired,
}

export default WithAuthentication
